import React from 'react';

const Hero = ({ onCreateClick }) => {
  return (
    <section 
      id="home" 
      className="relative min-h-[600px] md:min-h-[700px] overflow-hidden bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url('/hero-background.png')`,
      }}
    >
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-white/30"></div>

      <div className="container mx-auto px-6 relative z-10 py-20 md:py-32">
        <div className="max-w-4xl">
          <div className="inline-block backdrop-blur-0 bg-white/35 rounded-lg px-4 py-2">
            <h1 className="text-4xl sm:text-5xl md:text-5xl font-black mb-3 leading-tight text-gray-900" style={{ fontFamily: "'Diplomata', 'Arbutus', cursive" }}>
              Curate | Captivate | Connect
            </h1>
            <div className="w-full h-1.5 mt-4 bg-orange-500 mb-5"></div>
          </div>

          <div className="backdrop-blur-0 bg-white/50  rounded-xl p-4 md:p-6 mt-6 ">
            <p className="text-xl md:text-2xl text-gray-900 mb-2 mr-3 leading-relaxed font-medium" style={{ fontFamily: "'Hepta Slab', serif" }}>
              From Visualizing, Creative Designing, Event Strategy till Event Execution,<br />
              we get our hands in everything!
            </p>

            <p className="text-xl md:text-2xl text-gray-900 mb-0 font-bold" style={{ fontFamily: "'Hepta Slab', serif" }}>
              We just like our work perfectly done!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;